import { useMemo } from 'react';
import getStaticMapUrl from '@alltrails/core/utils/getStaticMapUrl';
import PhotoSizeDimensions from '@alltrails/types/PhotoSizeDimensions';
import StaticMapSize from '@alltrails/types/StaticMapSize';
import useCardPhotos from './useCardPhotos';

const useMapPhotos = (
  id: number,
  photoSize: PhotoSizeDimensions,
  mapSize: StaticMapSize,
  maxPhotos: number,
  baseUrl: string = '',
  isCustomRoute?: boolean
) => {
  const { photos, loadPhotos } = useCardPhotos('maps', id, photoSize, maxPhotos, isCustomRoute, baseUrl);

  const staticMapUrl = useMemo(
    () =>
      getStaticMapUrl({
        type: 'maps',
        id,
        size: mapSize,
        baseUrl,
        scale: 2,
        includePois: false
      }),
    [baseUrl, id, mapSize]
  );

  return useMemo(() => ({ staticMap: staticMapUrl, photos, loadPhotos }), [staticMapUrl, photos, loadPhotos]);
};

export default useMapPhotos;
